import React from "react";
import Button from "../../../ui/Button";
import { ACTION_STYLES } from "../../../../pages/constants/AiAgent";

const styleToVariant = {
  [ACTION_STYLES.primary]: "black",
  [ACTION_STYLES.secondary]: "secondary",
  [ACTION_STYLES.ghost]: "ghost",
};

export const ComponentActionButton = ({ label, action, params, style, onAction, disabled }) => {
  const variant = styleToVariant[style] || "secondary";

  return (
    <Button
      variant={variant}
      size="sm"
      className="!text-xs"
      onClick={() => onAction(action, params)}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};
